// You can write your custom Javascript here
(function($){$( document ).ready(function() {

    function productImages(){
    var matchArray = [];
    $('.single-option-selector').each(function(){
      matchArray.push($(this).val());
    });
    var matchString = matchArray.join(' / ');
    var selectedId = '';
    $('#product-select').find('option').each(function(){
      if ($(this).text() == matchString){
        selectedId = $(this).attr('value');
      }
    });

  
    const url = new URL(window.location);
    let productTemplate = $('body.template-product');
    if(productTemplate.length > 0){
      url.searchParams.set('variant', selectedId);
      window.history.pushState({}, '', url);
      
    }

    var bigTarget = $('.product__slider [data-otherimages]');
    var bigArray = bigTarget.attr('data-otherimages').split(',');
    
    var smallTarget = $('.product__thumbs [data-otherimages]');
    var smallArray = smallTarget.attr('data-otherimages').split(',');
    
    var structured = [];
    
    for (i=0;i<bigArray.length;i++){
      var bufferBigArray = bigArray[i].split(':');
      var bufferSmallArray = smallArray[i].split(':');

      var bufferObject = {
        "id": bufferBigArray[0],
        "bigSrc": bufferBigArray[1],
        "smallSrc": bufferSmallArray[1]
      };
      structured.push(bufferObject);
    }

    var selectedObj = structured.filter(obj => {
      return obj.id === selectedId
    });

    selectedObj = selectedObj[0];

    bigTarget.find('img').attr('src', selectedObj.bigSrc);
    smallTarget.find('img').attr('src', selectedObj.smallSrc);

  }

  
  $('.single-option-selector').on('change', function(){
    productImages();
  });

  $(window).on('load scroll', function(){
    //console.log($(this).scrollTop())
    if($(this).scrollTop() < 10){
      productImages();
    }
    productImages();
    const url = new URL(window.location);
    const urlVariant = url.searchParams.get('variant');
  });

  $('.template-cart .modalButton').on('click', function(){
    $('.modal').fadeIn();
  });

  $('.template-cart .modal__close').on('click', function(){
    $('.modal').fadeOut();
  });
  
  
}); })(jQuery);

// Move Klaviyo's back in stock button to replace "Sold Out" button

setInterval(function () {
  let klaviyoBIS_ready = jQuery('.klaviyo-bis-trigger');
  if(klaviyoBIS_ready.length) {
    jQuery('.template-product .bis-replace').after(klaviyoBIS_ready);
    jQuery('.template-product .bold_clone.bis-replace, .template-product .addtocart.bis-replace').remove();
    jQuery('.template-product .klaviyo-bis-trigger').addClass('bis-replace');
    return false;
  }
  console.log(klaviyoBIS_ready.length)
  if(klaviyoBIS_ready.length > 1){
    jQuery('.template-product .bis-replace').first().remove();
  }
}, 1000);